export type UiLanguage =
  | 'pt-BR'   // 🇧🇷 Português (Brasil)
  | 'pt-PT'   // 🇵🇹 Português (Portugal)
  | 'en-US'   // 🇺🇸 English
  | 'es-ES'   // 🇪🇸 Español
  | 'fr-FR';  // 🇫🇷 Français

export type I18nBaseLang = UiLanguage;

export interface LanguageOption {
  code: UiLanguage;        // o valor que a UI usa
  base: I18nBaseLang;      // o valor que passamos pro i18next.changeLanguage
  nativeLabel: string;     // rótulo nativo
  titleKey?: string;       // chave i18n opcional (ex.: 'language.portuguese_brazil')
}

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { code: 'pt-BR', base: 'pt-BR', nativeLabel: 'Português',  titleKey: 'language.pt_br' },
  { code: 'en-US', base: 'en-US', nativeLabel: 'English',    titleKey: 'language.en_us' },
  { code: 'es-ES', base: 'es-ES', nativeLabel: 'Español',    titleKey: 'language.es'    },
  { code: 'fr-FR', base: 'fr-FR', nativeLabel: 'Français',   titleKey: 'language.fr'    },
  { code: 'pt-PT', base: 'pt-PT', nativeLabel: 'Português',  titleKey: 'language.pt_pt' },
];

export function normalizeToI18n(lang: UiLanguage | I18nBaseLang): I18nBaseLang {
  return lang;
}